import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Image, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import FalconLightBoxGallery from 'components/common/FalconLightBoxGallery';

const ProjectGallery = ({ images }) => {
 return (
  <Card className="mb-3">
   <FalconCardHeader title="Galería" titleTag="h5" className="bg-light" />
   <Card.Body className="position-relative">
    <FalconLightBoxGallery images={images}>
     {setImgIndex => (
      <Row className="g-2">
       {images
        .filter((_, i) => i < 4)
        .map((img, i) => (
         <Col xs={3} key={i}>
          <Image src={img} fluid rounded className="cursor-pointer" onClick={() => setImgIndex(i)} />
         </Col>
        ))}
      </Row>
     )}
    </FalconLightBoxGallery>
   </Card.Body>
  </Card>
 );
};

ProjectGallery.propTypes = {
 images: PropTypes.array
};

export default ProjectGallery;
